import { render, staticRenderFns } from "./logisticsList.vue?vue&type=template&id=6176a458&scoped=true&"
import script from "./logisticsList.vue?vue&type=script&lang=js&"
export * from "./logisticsList.vue?vue&type=script&lang=js&"
import style0 from "./logisticsList.vue?vue&type=style&index=0&id=6176a458&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6176a458",
  null
  
)

export default component.exports